<template>
    <div class="chunk-error" role="alert">
        <p class="chunk-error__text">{{ $t('chunkLoadFailed') }}</p>
        <button type="button" class="chunk-error__button" @click="reload">
            {{ $t('chunkLoadRetry') }}
        </button>
    </div>
</template>

<script>
/**
 * Показывается, когда ленивый чанк не загрузился.
 *
 * Молчаливо пустое место недопустимо: на мобильной сети обрыв загрузки чанка
 * реален, и без сообщения человек видит статью без редактора и не понимает,
 * почему.
 */
export default {
    name: 'ChunkError',
    // Vue 2 отдаёт error-компоненту тот же `data`, что стоял на асинхронном
    // теге, а пропов здесь нет — значит без этой строки всё уедет в атрибуты
    // корневого div. У ArticleBodyEditor на редакторе висит `v-model`, то есть
    // в атрибут `value` попало бы всё тело статьи целиком.
    inheritAttrs: false,
    methods: {
        /**
         * Именно перезагрузка страницы, а не повторная попытка импорта.
         * resolveAsyncComponent первой же строкой возвращает errorComp, пока
         * `factory.error` истинно, и это состояние живёт на самом объекте-
         * фабрике — так что не помогает даже перемонтирование по :key. Честный
         * повтор потребовал бы новой функции-фабрики на каждую попытку.
         */
        reload() {
            window.location.reload();
        },
    },
};
</script>

<style scoped>
.chunk-error {
    padding: 16px;
    text-align: center;
}

.chunk-error__text {
    margin-bottom: 8px;
    color: #3C3E53;
}

.chunk-error__button {
    color: #4680FF;
    text-decoration: underline;
}
</style>
